import { render, staticRenderFns } from "./SearchPoiToEdit.vue?vue&type=template&id=480ab9ef&scoped=true&"
import script from "./SearchPoiToEdit.vue?vue&type=script&lang=js&"
export * from "./SearchPoiToEdit.vue?vue&type=script&lang=js&"
import style0 from "./SearchPoiToEdit.vue?vue&type=style&index=0&id=480ab9ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ab9ef",
  null
  
)

export default component.exports